import React, {Component} from 'react'
import PropTypes from 'prop-types'
import * as util from './util'

class Parallax extends Component {
  static propTypes = {
    children: PropTypes.element,
    wrapperClass: PropTypes.string.isRequired,
    imageClass: PropTypes.string.isRequired,
    step: PropTypes.number
  }

  constructor(props) {
		super(props)

    this.step = props.step ? props.step : 100
    this.isDocumentAvailable = util.isDocumentAvailable()
    this.timestamp = Date.now()
  }

  componentDidMount() {
    if (!this.isDocumentAvailable) return

    this.wrapperClass = '.' + this.props.wrapperClass
    this.imageClass = '.' + this.props.imageClass
    this.windowHeight = util.getWindowHeight()
    this.parallaxList = this.getParallaxList()

    this.updateImageHeight()

    this.addListeners()
  }

  componentWillUnmount() {
    if (!this.isDocumentAvailable) return

    this.removeListeners()
  }

  getParallaxList = () => {
    let wrappers = Array.from(this.parallax.querySelectorAll(this.wrapperClass))

    wrappers.forEach(wrapper => {
      let image = wrapper.querySelector(this.imageClass)
      image.style.transition = 'none'
    })

    return wrappers
  }

  addListeners = () => {
    document.addEventListener('scroll', this.onScroll, false)
    window.addEventListener('resize', this.onWindowResize, false)
    window.addEventListener('load', this.onWindowLoad, false)
  }

  removeListeners = () => {
    document.removeEventListener('scroll', this.onScroll, false)
    window.removeEventListener('resize', this.onWindowResize, false)
    window.removeEventListener('load', this.onWindowLoad, false)
  }

  onScroll = (event) => {
    const now = Date.now()

    if (now - this.timestamp >= 10) {
      window.requestAnimationFrame(this.updatePosition)
      this.timestamp = now
    }
  }

  onWindowResize = () => {
    this.windowHeight = util.getWindowHeight()
    this.updatePosition()
	}

  onWindowLoad = () => {
    this.updateImageHeight()
    this.updatePosition()
  }

  /**
	 * The image height depends on parallax direction. If step value is negative we have to give it more height
	 * so there is no white space at start/end of container visiblility.
	 */
	updateImageHeight = () => {
    if (!this.parallaxList) return

    this.parallaxList.forEach(wrapper => {
      const imageHeight = wrapper.getBoundingClientRect().height
      const parallaxHeight = Math.floor(imageHeight + (this.step < 0 ? 2.5 : 1) * Math.abs(this.step))
      const image = wrapper.querySelector(this.imageClass)
      image.style.height = parallaxHeight + 'px'
    })
	}

  updatePosition = () => {
    if (!this.parallaxList) return

    this.parallaxList.forEach(wrapper => {
      const image = wrapper.querySelector(this.imageClass)
      const percentage = util.getRelativePosition(wrapper, this.windowHeight)
      this.setImagePosition(image, percentage)
    })
	}

  setImagePosition = (image, percentage) => {
		let pos = (this.step < 0 ? this.step : 0) - (this.step * percentage);
    pos = Math.floor(pos)

    image.style.WebkitTransform = `translate3d(0, ${pos}px, 0)`
    image.style.transform = `translate3d(0, ${pos}px, 0)`
	}

  render = () => (
    <div ref={el => this.parallax = el}>{this.props.children}</div>
  )
}

export default Parallax



// WEBPACK FOOTER //
// ./src/components/Parallax/index.js